import { memo } from 'react'
import useCruiseFAQ from './FaqHelper'
import CruiseFAQSection from './CruiseFAQSection'
interface Props {
  cruiseLine: App.CruiseLine
  ship: App.CruiseShip
  cruiseType: App.CruiseType
}

function CruiseFAQ({ cruiseLine, ship, cruiseType }: Props) {
  const faq = useCruiseFAQ(cruiseLine, ship, cruiseType)

  return (
    <>
      {faq.map((faqSection, index) => (
        <CruiseFAQSection key={index} FAQItem={faqSection} />
      ))}
    </>
  )
}

export default memo(CruiseFAQ)
